import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintReceiptNiceloopV1Builder from "~/class/printer/PrintReceiptNiceloopV1Builder";


export default class ThermalPrintReceipt extends ThermalPrinterBase {  
  printReceipt(receipt: any, options:any = {}){
    const printReceiptNiceloopV1 = this.withPayload(receipt, options)

    console.log("print receipt=>", printReceiptNiceloopV1)
    this.print_data = printReceiptNiceloopV1
    
    return this;
  }
  
  withPayload(receipt: any, options: any = {}){
    const printReceiptNiceloopV1 = new PrintReceiptNiceloopV1Builder(receipt).build({isCopy: receipt.isCopy || false, ...options});
    return printReceiptNiceloopV1
  }

  setPayload(payload: any){
    this.print_data = payload
    return this
  }
}
